// Vervaldatum-defaults per emmertype (audit 2026-07-02, fix 2).
//
// De verlofsaldo-import gebruikte één type-agnostische default ("31-12 van
// jaar+1") waardoor geïmporteerde WETTELIJK-emmers een dag te vroeg
// (30-06 i.p.v. 01-07) en TVT_WERK-emmers een jaar te ruim vervielen. Deze
// helper spiegelt de engine-paden exact zoals die in de UTC-productiecontainer
// materialiseren:
//   - WETTELIJK:      1 juli van jaar+1  (leave-entitlements.ts
//                     `new Date(year + 1, 6, 1)` — art. 7:640a BW: opneembaar
//                     t/m 30 juni, vervalt per 1 juli)
//   - BOVENWETTELIJK: 31 december van jaar+5 (5-jaarstermijn)
//   - ATV:            31 december van het opbouwjaar
//   - TVT_WERK/REIS:  31 december 23:59:59 van het opbouwjaar (identiek aan de
//                     emmer-`expiresAt` die uren.ts/tvt-verval.ts zetten)
//
// OUDERSCHAP_*/SENIORENVERLOF hebben eigen, context-afhankelijke vervaldata
// (kind-leeftijd resp. peildatum + beleid) en vallen bewust buiten deze helper.

export type VervalDatumEmmerType =
  | 'WETTELIJK'
  | 'BOVENWETTELIJK'
  | 'ATV'
  | 'TVT_WERK'
  | 'TVT_REIS'

/**
 * Default-vervaldatum voor een klassieke emmer van opbouwjaar `year`.
 * UTC-gepind zodat lokale host-tz (tests/dev) dezelfde instant oplevert als de
 * UTC-productiecontainer.
 */
export function vervalDatumVoorType(type: VervalDatumEmmerType, year: number): Date {
  switch (type) {
    case 'WETTELIJK':
      return new Date(Date.UTC(year + 1, 6, 1))
    case 'BOVENWETTELIJK':
      return new Date(Date.UTC(year + 5, 11, 31))
    case 'ATV':
      return new Date(Date.UTC(year, 11, 31))
    case 'TVT_WERK':
    case 'TVT_REIS':
      return new Date(Date.UTC(year, 11, 31, 23, 59, 59))
  }
}
